import { FamilyService } from '@/services/api/familyService';
import { UserService } from '@/services/api/userService';
import { ClassService } from '@/services/classServices';
import { studentService } from '@/services/studentService';

/**
 * Hook that provides access to data services
 * This centralizes access to all services from components
 */
export const useDataServices = () => {
  return {
    // User and auth services
    user: UserService,
    
    // Family-related services
    family: {
      // Re-export all FamilyService methods
      ...FamilyService,
      // Add parents methods from FamilyService
      addFamily: FamilyService.addFamily,
      addParent: FamilyService.addParent,
      addStudent: FamilyService.addStudent,
      getFamilies: FamilyService.getFamilies,
    },
    
    // Class-related services
    class: ClassService,
    
    // Student-related services
    student: studentService,
  };
};
